import { Sport } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const sportDictionary = createSimpleDictionary([
    { id: Sport.Football, name: 'dictionaries.sport.football' },
    { id: Sport.Basketball, name: 'dictionaries.sport.basketball' },
]);
